<div class="reports-list" *ngIf="!loadingReports">
  <div class="reports-list__items">
    <ng-container *ngIf="reportList$ | async as reportList">
      <div
        *ngFor="let report of reportList"
        class="reports-list__row"
        [class.reports-list__row--current]="report.id === currentReport?.id"
        (click)="selectReport(report)"
      >
        <div class="reports-list__row-name">
          {{ setReportTitle(report) }}
        </div>
        <div class="reports-list__row-status">
          <span class="reports-list__status">{{
            report.active ? 'Active' : 'Inactive'
          }}</span>
          <mat-slide-toggle
            [checked]="report.active"
            (change)="reportStatusUpdate($event.checked, report)"
            (click)="$event.stopPropagation()"
          ></mat-slide-toggle>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="reports-list__actions">
    <button
      type="button"
      class="reports-list__create"
      (click)="createReport()"
      id="create-report"
    >
      <mat-icon>add</mat-icon>
      <span>Create Report</span>
    </button>
  </div>
</div>
<div class="reports-list__loading" *ngIf="loadingReports">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
